<template>
  <span>
    <card shadow v-if="$store.state.main.userRole === 'limited_facilitator'">
      <iframe src="https://player.vimeo.com/video/790774762?h=217a2dbad1" width="800" height="200" frameborder="0" allow="autoplay; fullscreen" allowfullscreen/>

      <br/>

      Jos video ei vastannut kaikkiin kysymyksiisi, lähetä meille viestiä fasilitaattorituki@smoothteam.fi ja autamme sinua pikaisesti!

    </card>
  </span>
</template>

<script>
export default {
  methods: {

  },
  computed: {
  },
};
</script>
